export interface CountryData {
  name: string;
  iso: string;
  dialCode: string;
  flag: string;
}

const flag = (iso: string) =>
  String.fromCodePoint(...[...iso.toUpperCase()].map(c => 0x1f1e6 + c.charCodeAt(0) - 65));

export const COUNTRIES: CountryData[] = [
  // Common countries first
  { name: 'United States', iso: 'US', dialCode: '+1', flag: flag('US') },
  { name: 'Canada', iso: 'CA', dialCode: '+1', flag: flag('CA') },
  { name: 'United Kingdom', iso: 'GB', dialCode: '+44', flag: flag('GB') },
  { name: 'Australia', iso: 'AU', dialCode: '+61', flag: flag('AU') },
  { name: 'India', iso: 'IN', dialCode: '+91', flag: flag('IN') },
  { name: 'Japan', iso: 'JP', dialCode: '+81', flag: flag('JP') },
  { name: 'South Korea', iso: 'KR', dialCode: '+82', flag: flag('KR') },
  { name: 'China', iso: 'CN', dialCode: '+86', flag: flag('CN') },
  { name: 'Germany', iso: 'DE', dialCode: '+49', flag: flag('DE') },
  { name: 'France', iso: 'FR', dialCode: '+33', flag: flag('FR') },
  { name: 'Brazil', iso: 'BR', dialCode: '+55', flag: flag('BR') },
  { name: 'Mexico', iso: 'MX', dialCode: '+52', flag: flag('MX') },
  // Alphabetical
  { name: 'Afghanistan', iso: 'AF', dialCode: '+93', flag: flag('AF') },
  { name: 'Albania', iso: 'AL', dialCode: '+355', flag: flag('AL') },
  { name: 'Algeria', iso: 'DZ', dialCode: '+213', flag: flag('DZ') },
  { name: 'Andorra', iso: 'AD', dialCode: '+376', flag: flag('AD') },
  { name: 'Angola', iso: 'AO', dialCode: '+244', flag: flag('AO') },
  { name: 'Argentina', iso: 'AR', dialCode: '+54', flag: flag('AR') },
  { name: 'Armenia', iso: 'AM', dialCode: '+374', flag: flag('AM') },
  { name: 'Austria', iso: 'AT', dialCode: '+43', flag: flag('AT') },
  { name: 'Azerbaijan', iso: 'AZ', dialCode: '+994', flag: flag('AZ') },
  { name: 'Bahamas', iso: 'BS', dialCode: '+1242', flag: flag('BS') },
  { name: 'Bahrain', iso: 'BH', dialCode: '+973', flag: flag('BH') },
  { name: 'Bangladesh', iso: 'BD', dialCode: '+880', flag: flag('BD') },
  { name: 'Barbados', iso: 'BB', dialCode: '+1246', flag: flag('BB') },
  { name: 'Belarus', iso: 'BY', dialCode: '+375', flag: flag('BY') },
  { name: 'Belgium', iso: 'BE', dialCode: '+32', flag: flag('BE') },
  { name: 'Belize', iso: 'BZ', dialCode: '+501', flag: flag('BZ') },
  { name: 'Benin', iso: 'BJ', dialCode: '+229', flag: flag('BJ') },
  { name: 'Bhutan', iso: 'BT', dialCode: '+975', flag: flag('BT') },
  { name: 'Bolivia', iso: 'BO', dialCode: '+591', flag: flag('BO') },
  { name: 'Bosnia and Herzegovina', iso: 'BA', dialCode: '+387', flag: flag('BA') },
  { name: 'Botswana', iso: 'BW', dialCode: '+267', flag: flag('BW') },
  { name: 'Brunei', iso: 'BN', dialCode: '+673', flag: flag('BN') },
  { name: 'Bulgaria', iso: 'BG', dialCode: '+359', flag: flag('BG') },
  { name: 'Burkina Faso', iso: 'BF', dialCode: '+226', flag: flag('BF') },
  { name: 'Burundi', iso: 'BI', dialCode: '+257', flag: flag('BI') },
  { name: 'Cambodia', iso: 'KH', dialCode: '+855', flag: flag('KH') },
  { name: 'Cameroon', iso: 'CM', dialCode: '+237', flag: flag('CM') },
  { name: 'Cape Verde', iso: 'CV', dialCode: '+238', flag: flag('CV') },
  { name: 'Central African Republic', iso: 'CF', dialCode: '+236', flag: flag('CF') },
  { name: 'Chad', iso: 'TD', dialCode: '+235', flag: flag('TD') },
  { name: 'Chile', iso: 'CL', dialCode: '+56', flag: flag('CL') },
  { name: 'Colombia', iso: 'CO', dialCode: '+57', flag: flag('CO') },
  { name: 'Comoros', iso: 'KM', dialCode: '+269', flag: flag('KM') },
  { name: 'Congo (DRC)', iso: 'CD', dialCode: '+243', flag: flag('CD') },
  { name: 'Congo (Republic)', iso: 'CG', dialCode: '+242', flag: flag('CG') },
  { name: 'Costa Rica', iso: 'CR', dialCode: '+506', flag: flag('CR') },
  { name: 'Croatia', iso: 'HR', dialCode: '+385', flag: flag('HR') },
  { name: 'Cuba', iso: 'CU', dialCode: '+53', flag: flag('CU') },
  { name: 'Cyprus', iso: 'CY', dialCode: '+357', flag: flag('CY') },
  { name: 'Czech Republic', iso: 'CZ', dialCode: '+420', flag: flag('CZ') },
  { name: 'Denmark', iso: 'DK', dialCode: '+45', flag: flag('DK') },
  { name: 'Djibouti', iso: 'DJ', dialCode: '+253', flag: flag('DJ') },
  { name: 'Dominican Republic', iso: 'DO', dialCode: '+1809', flag: flag('DO') },
  { name: 'Ecuador', iso: 'EC', dialCode: '+593', flag: flag('EC') },
  { name: 'Egypt', iso: 'EG', dialCode: '+20', flag: flag('EG') },
  { name: 'El Salvador', iso: 'SV', dialCode: '+503', flag: flag('SV') },
  { name: 'Equatorial Guinea', iso: 'GQ', dialCode: '+240', flag: flag('GQ') },
  { name: 'Eritrea', iso: 'ER', dialCode: '+291', flag: flag('ER') },
  { name: 'Estonia', iso: 'EE', dialCode: '+372', flag: flag('EE') },
  { name: 'Eswatini', iso: 'SZ', dialCode: '+268', flag: flag('SZ') },
  { name: 'Ethiopia', iso: 'ET', dialCode: '+251', flag: flag('ET') },
  { name: 'Fiji', iso: 'FJ', dialCode: '+679', flag: flag('FJ') },
  { name: 'Finland', iso: 'FI', dialCode: '+358', flag: flag('FI') },
  { name: 'Gabon', iso: 'GA', dialCode: '+241', flag: flag('GA') },
  { name: 'Gambia', iso: 'GM', dialCode: '+220', flag: flag('GM') },
  { name: 'Georgia', iso: 'GE', dialCode: '+995', flag: flag('GE') },
  { name: 'Ghana', iso: 'GH', dialCode: '+233', flag: flag('GH') },
  { name: 'Greece', iso: 'GR', dialCode: '+30', flag: flag('GR') },
  { name: 'Grenada', iso: 'GD', dialCode: '+1473', flag: flag('GD') },
  { name: 'Guatemala', iso: 'GT', dialCode: '+502', flag: flag('GT') },
  { name: 'Guinea', iso: 'GN', dialCode: '+224', flag: flag('GN') },
  { name: 'Guinea-Bissau', iso: 'GW', dialCode: '+245', flag: flag('GW') },
  { name: 'Guyana', iso: 'GY', dialCode: '+592', flag: flag('GY') },
  { name: 'Haiti', iso: 'HT', dialCode: '+509', flag: flag('HT') },
  { name: 'Honduras', iso: 'HN', dialCode: '+504', flag: flag('HN') },
  { name: 'Hong Kong', iso: 'HK', dialCode: '+852', flag: flag('HK') },
  { name: 'Hungary', iso: 'HU', dialCode: '+36', flag: flag('HU') },
  { name: 'Iceland', iso: 'IS', dialCode: '+354', flag: flag('IS') },
  { name: 'Indonesia', iso: 'ID', dialCode: '+62', flag: flag('ID') },
  { name: 'Iran', iso: 'IR', dialCode: '+98', flag: flag('IR') },
  { name: 'Iraq', iso: 'IQ', dialCode: '+964', flag: flag('IQ') },
  { name: 'Ireland', iso: 'IE', dialCode: '+353', flag: flag('IE') },
  { name: 'Israel', iso: 'IL', dialCode: '+972', flag: flag('IL') },
  { name: 'Italy', iso: 'IT', dialCode: '+39', flag: flag('IT') },
  { name: 'Ivory Coast', iso: 'CI', dialCode: '+225', flag: flag('CI') },
  { name: 'Jamaica', iso: 'JM', dialCode: '+1876', flag: flag('JM') },
  { name: 'Jordan', iso: 'JO', dialCode: '+962', flag: flag('JO') },
  { name: 'Kazakhstan', iso: 'KZ', dialCode: '+7', flag: flag('KZ') },
  { name: 'Kenya', iso: 'KE', dialCode: '+254', flag: flag('KE') },
  { name: 'Kuwait', iso: 'KW', dialCode: '+965', flag: flag('KW') },
  { name: 'Kyrgyzstan', iso: 'KG', dialCode: '+996', flag: flag('KG') },
  { name: 'Laos', iso: 'LA', dialCode: '+856', flag: flag('LA') },
  { name: 'Latvia', iso: 'LV', dialCode: '+371', flag: flag('LV') },
  { name: 'Lebanon', iso: 'LB', dialCode: '+961', flag: flag('LB') },
  { name: 'Lesotho', iso: 'LS', dialCode: '+266', flag: flag('LS') },
  { name: 'Liberia', iso: 'LR', dialCode: '+231', flag: flag('LR') },
  { name: 'Libya', iso: 'LY', dialCode: '+218', flag: flag('LY') },
  { name: 'Liechtenstein', iso: 'LI', dialCode: '+423', flag: flag('LI') },
  { name: 'Lithuania', iso: 'LT', dialCode: '+370', flag: flag('LT') },
  { name: 'Luxembourg', iso: 'LU', dialCode: '+352', flag: flag('LU') },
  { name: 'Macau', iso: 'MO', dialCode: '+853', flag: flag('MO') },
  { name: 'Madagascar', iso: 'MG', dialCode: '+261', flag: flag('MG') },
  { name: 'Malawi', iso: 'MW', dialCode: '+265', flag: flag('MW') },
  { name: 'Malaysia', iso: 'MY', dialCode: '+60', flag: flag('MY') },
  { name: 'Maldives', iso: 'MV', dialCode: '+960', flag: flag('MV') },
  { name: 'Mali', iso: 'ML', dialCode: '+223', flag: flag('ML') },
  { name: 'Malta', iso: 'MT', dialCode: '+356', flag: flag('MT') },
  { name: 'Mauritania', iso: 'MR', dialCode: '+222', flag: flag('MR') },
  { name: 'Mauritius', iso: 'MU', dialCode: '+230', flag: flag('MU') },
  { name: 'Moldova', iso: 'MD', dialCode: '+373', flag: flag('MD') },
  { name: 'Monaco', iso: 'MC', dialCode: '+377', flag: flag('MC') },
  { name: 'Mongolia', iso: 'MN', dialCode: '+976', flag: flag('MN') },
  { name: 'Montenegro', iso: 'ME', dialCode: '+382', flag: flag('ME') },
  { name: 'Morocco', iso: 'MA', dialCode: '+212', flag: flag('MA') },
  { name: 'Mozambique', iso: 'MZ', dialCode: '+258', flag: flag('MZ') },
  { name: 'Myanmar', iso: 'MM', dialCode: '+95', flag: flag('MM') },
  { name: 'Namibia', iso: 'NA', dialCode: '+264', flag: flag('NA') },
  { name: 'Nepal', iso: 'NP', dialCode: '+977', flag: flag('NP') },
  { name: 'Netherlands', iso: 'NL', dialCode: '+31', flag: flag('NL') },
  { name: 'New Zealand', iso: 'NZ', dialCode: '+64', flag: flag('NZ') },
  { name: 'Nicaragua', iso: 'NI', dialCode: '+505', flag: flag('NI') },
  { name: 'Niger', iso: 'NE', dialCode: '+227', flag: flag('NE') },
  { name: 'Nigeria', iso: 'NG', dialCode: '+234', flag: flag('NG') },
  { name: 'North Macedonia', iso: 'MK', dialCode: '+389', flag: flag('MK') },
  { name: 'Norway', iso: 'NO', dialCode: '+47', flag: flag('NO') },
  { name: 'Oman', iso: 'OM', dialCode: '+968', flag: flag('OM') },
  { name: 'Pakistan', iso: 'PK', dialCode: '+92', flag: flag('PK') },
  { name: 'Palestine', iso: 'PS', dialCode: '+970', flag: flag('PS') },
  { name: 'Panama', iso: 'PA', dialCode: '+507', flag: flag('PA') },
  { name: 'Papua New Guinea', iso: 'PG', dialCode: '+675', flag: flag('PG') },
  { name: 'Paraguay', iso: 'PY', dialCode: '+595', flag: flag('PY') },
  { name: 'Peru', iso: 'PE', dialCode: '+51', flag: flag('PE') },
  { name: 'Philippines', iso: 'PH', dialCode: '+63', flag: flag('PH') },
  { name: 'Poland', iso: 'PL', dialCode: '+48', flag: flag('PL') },
  { name: 'Portugal', iso: 'PT', dialCode: '+351', flag: flag('PT') },
  { name: 'Puerto Rico', iso: 'PR', dialCode: '+1787', flag: flag('PR') },
  { name: 'Qatar', iso: 'QA', dialCode: '+974', flag: flag('QA') },
  { name: 'Romania', iso: 'RO', dialCode: '+40', flag: flag('RO') },
  { name: 'Russia', iso: 'RU', dialCode: '+7', flag: flag('RU') },
  { name: 'Rwanda', iso: 'RW', dialCode: '+250', flag: flag('RW') },
  { name: 'Saudi Arabia', iso: 'SA', dialCode: '+966', flag: flag('SA') },
  { name: 'Senegal', iso: 'SN', dialCode: '+221', flag: flag('SN') },
  { name: 'Serbia', iso: 'RS', dialCode: '+381', flag: flag('RS') },
  { name: 'Sierra Leone', iso: 'SL', dialCode: '+232', flag: flag('SL') },
  { name: 'Singapore', iso: 'SG', dialCode: '+65', flag: flag('SG') },
  { name: 'Slovakia', iso: 'SK', dialCode: '+421', flag: flag('SK') },
  { name: 'Slovenia', iso: 'SI', dialCode: '+386', flag: flag('SI') },
  { name: 'Somalia', iso: 'SO', dialCode: '+252', flag: flag('SO') },
  { name: 'South Africa', iso: 'ZA', dialCode: '+27', flag: flag('ZA') },
  { name: 'Spain', iso: 'ES', dialCode: '+34', flag: flag('ES') },
  { name: 'Sri Lanka', iso: 'LK', dialCode: '+94', flag: flag('LK') },
  { name: 'Sudan', iso: 'SD', dialCode: '+249', flag: flag('SD') },
  { name: 'Suriname', iso: 'SR', dialCode: '+597', flag: flag('SR') },
  { name: 'Sweden', iso: 'SE', dialCode: '+46', flag: flag('SE') },
  { name: 'Switzerland', iso: 'CH', dialCode: '+41', flag: flag('CH') },
  { name: 'Syria', iso: 'SY', dialCode: '+963', flag: flag('SY') },
  { name: 'Taiwan', iso: 'TW', dialCode: '+886', flag: flag('TW') },
  { name: 'Tajikistan', iso: 'TJ', dialCode: '+992', flag: flag('TJ') },
  { name: 'Tanzania', iso: 'TZ', dialCode: '+255', flag: flag('TZ') },
  { name: 'Thailand', iso: 'TH', dialCode: '+66', flag: flag('TH') },
  { name: 'Togo', iso: 'TG', dialCode: '+228', flag: flag('TG') },
  { name: 'Trinidad and Tobago', iso: 'TT', dialCode: '+1868', flag: flag('TT') },
  { name: 'Tunisia', iso: 'TN', dialCode: '+216', flag: flag('TN') },
  { name: 'Turkey', iso: 'TR', dialCode: '+90', flag: flag('TR') },
  { name: 'Turkmenistan', iso: 'TM', dialCode: '+993', flag: flag('TM') },
  { name: 'Uganda', iso: 'UG', dialCode: '+256', flag: flag('UG') },
  { name: 'Ukraine', iso: 'UA', dialCode: '+380', flag: flag('UA') },
  { name: 'United Arab Emirates', iso: 'AE', dialCode: '+971', flag: flag('AE') },
  { name: 'Uruguay', iso: 'UY', dialCode: '+598', flag: flag('UY') },
  { name: 'Uzbekistan', iso: 'UZ', dialCode: '+998', flag: flag('UZ') },
  { name: 'Venezuela', iso: 'VE', dialCode: '+58', flag: flag('VE') },
  { name: 'Vietnam', iso: 'VN', dialCode: '+84', flag: flag('VN') },
  { name: 'Yemen', iso: 'YE', dialCode: '+967', flag: flag('YE') },
  { name: 'Zambia', iso: 'ZM', dialCode: '+260', flag: flag('ZM') },
  { name: 'Zimbabwe', iso: 'ZW', dialCode: '+263', flag: flag('ZW') },
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // United States
